import type { TaskDto, TaskScope } from '@bk/contracts';
import { useState } from 'react';
import { errorMessage } from '../../lib/api';
import { useTenant, useTenantQuery } from '../../lib/useTenant';
import { Button, Empty, ErrorText, PageTitle } from '../../ui';
import { MyProcedureTasks } from './MyProcedureTasks';
import { TaskCard } from './TaskCard';

/** "Oggi": i miei task; per i responsabili anche tutti quelli aperti e quelli da assegnare. */
export function Today() {
  const { isManager, tenant } = useTenant();
  const taskOnly = tenant.access_scope === 'tasks';
  const [scope, setScope] = useState<TaskScope>(isManager ? 'open' : 'mine');
  const tasks = useTenantQuery<{ data: TaskDto[] }>(['tasks', scope], `/tasks?scope=${scope}`, { refetchInterval: 15_000 });
  const tab = (id: TaskScope, label: string) => (
    <Button variant="ghost" className={scope === id ? 'bg-black/5 text-ink' : ''} onClick={() => setScope(id)}>
      {label}
    </Button>
  );
  return (
    <>
      <PageTitle
        title={taskOnly ? 'I tuoi compiti' : 'Oggi'}
        subtitle="Le cose da fare, chiuse a mano da chi le esegue o dal responsabile per suo conto."
        actions={
          <div className="flex gap-1">
            {tab('mine', 'I miei task')}
            {isManager && tab('open', 'Tutti gli aperti')}
            {isManager && tab('unassigned', 'Da assegnare')}
          </div>
        }
      />
      <MyProcedureTasks scope={scope} />
      <ErrorText>{tasks.error ? errorMessage(tasks.error) : ''}</ErrorText>
      {tasks.data?.data.length === 0 && (
        <Empty>{taskOnly ? 'Nessun altro compito assegnato a te.' : scope === 'mine' ? 'Nessun task assegnato a te. Collega il tuo account a una persona in "Persone" per vedere i tuoi.' : 'Nessun task aperto.'}</Empty>
      )}
      <div className="grid gap-3 md:grid-cols-2">
        {tasks.data?.data.map((task) => <TaskCard key={task.id} task={task} />)}
      </div>
    </>
  );
}
